import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import Tooltip from '../../../components/Tooltip';
import './ProjectCardStatus.scss';

import {
  REGISTER_STATUS, ACTIVE_STATUS,
  PAUSED_STATUS, FAILED_STATUS,
  CLOSED_STATUS, TERMINATED_STATUS,
} from '../../../constans/constans';

import registerIcon from '../../../assets/image/existing-projects/time-square-small.svg';
import mintedIcon from '../../../assets/image/existing-projects/checked-square-small.svg';
import pausedIcon from '../../../assets/image/existing-projects/pause-square-small.svg';
import endedIcon from '../../../assets/image/existing-projects/reward-square-small.svg';
import failedIcon from '../../../assets/image/existing-projects/close-square-small.svg';

const ProjectCardStatus = ({ status, projectId, isStagesFinished }) => {
  const translate = useIntl();

  const tooltips = useMemo(() => ({
    [REGISTER_STATUS]: {
      icon: <img src={registerIcon} data-tip data-for={projectId} alt="Register status" />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.status.register' }),
      uniqueProps: { textColor: '#FABC73', borderColor: '#FABC73', offset: { right: 98 } },
    },
    [ACTIVE_STATUS]: {
      icon: isStagesFinished
        ? <img src={endedIcon} data-tip data-for={projectId} alt="Ended status" />
        : <img src={mintedIcon} data-tip data-for={projectId} alt="Active status" />,
      text: isStagesFinished
        ? translate.formatMessage({ id: 'projectCard.toolTip.status.ended' })
        : translate.formatMessage({ id: 'projectCard.toolTip.status.minted' }),
      uniqueProps: { textColor: '#329D9C', borderColor: '#329D9C', offset: { right: 98 } },
    },
    [PAUSED_STATUS]: {
      icon: <img src={pausedIcon} data-tip data-for={projectId} alt="Paused status" />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.status.paused' }),
      uniqueProps: { textColor: '#FABC73', borderColor: '#FABC73', offset: { right: 98 } },
    },
    [CLOSED_STATUS]: {
      icon: <img src={endedIcon} data-tip data-for={projectId} alt="Closed status" />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.status.ended' }),
      uniqueProps: { textColor: '#329D9C', borderColor: '#329D9C', offset: { right: 98 } },
    },
    [FAILED_STATUS]: {
      icon: <img src={failedIcon} data-tip data-for={projectId} alt="Failed status" />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.status.failed' }),
      uniqueProps: { textColor: '#FF8080', borderColor: '#FF8080', offset: { right: 98 } },
    },
    [TERMINATED_STATUS]: {
      icon: <img src={failedIcon} data-tip data-for={projectId} alt="Terminated status" />,
      text: translate.formatMessage({ id: 'projectCard.toolTip.status.terminated' }),
      uniqueProps: { textColor: '#FF8080', borderColor: '#FF8080', offset: { right: 98 } },
    },
  }), []);

  const activeTooltip = tooltips[status];

  return activeTooltip ? (
    <div className="card-status">
      <Tooltip
        targetClass="icon-wrapper"
        targetElement={activeTooltip.icon}
        tooltipElement={activeTooltip.text}
        tooltipProps={{
          className: 'status-tooltip',
          place: 'top',
          type: 'light',
          id: projectId,
          effect: 'solid',
          border: true,
          ...activeTooltip.uniqueProps,
        }}
      />
    </div>
  ) : null;
};

export default ProjectCardStatus;
